import * as React from 'react'
import * as UniversalRouter from 'universal-router'
import { TopicPreferencesConnected } from './component'
import * as Constants from './constants'

export const routes = [
  {
    action: (context: UniversalRouter.ActionContext) => <TopicPreferencesConnected />,
    path: `${Constants.URL_HOME}/:community_identifier`,
  },
]